export const studentEvals = [
  "\"Amazing professor who cares about his students. Made the class even more enjoyabble!! :)\"",

  "\"Best instructor ever. So friendly and patient, and I really enjoyed his classes.\"",

  "\"I liked how he gave detailed answers to student's questions. When I would answer discussion questions, they might have seemed like a stretch. But Gainey would always show how the answers given could be connected back to the current discussion topic.\"",

  "\"Mike was wonderful. Extremely friendly, charismatic, and enthusiastic about the course material. He made me feel welcomed in class every day and never made it a stressful environment.\"",
  "\"Mr. Gainey is an excellent teacher and WCWP 10B was one of my favorite classes that I took this spring quarter.\"",

  "\"He was a great instructor and I learned a lot - very helpful and friendly.\"",

  "\"Mike Gainey is a fantastic instructor that genuinely cares about the success of his students. Live sections are engaging and he knows how to facilitate group discussion very well, even when the class is unresponsive. Written and verbal feedback are personalized and thorough, genuinely helpful.\"",

  "\"Mr. Gainey was an excellent teacher. I learned a lot about writing effectively from him, and could not have asked for a better instructor.\"",

  "\"Mike Gainey is very easy to talk to, he knows how to listen and make the correct comments to nudge you in the correct direction for how to write your papers.\"",

  "\"Honestly loved Mike as an instructor, he did a great job in many ways. One of the things I liked most was his ability to stimulate thought provoking, yet open minded discussion that accepted all views, and probed people to think more about their stance to create a defendable argument.\"",

  "\"Even when the class was quiet, he was still calm and trying to lead the class for discussion. He's also by far the most chill guy teaching here at UCSD. His whole vibe makes for a easy feeling class.\"",

  "\"Literally such a good IA.\"",

  "\"AMAZING MAN 10/10\"",

  "\"Mike is great. He's a kind and effective IA.\"",

  "\"Mike was kind and helpful. He encouraged class participation and discussions were engaging. He showed he cared by taking the time to remember our names on the first day and then always asking us about our opinions. He stimulated class conversation very well.\"",

  "\"He created a welcoming and supportive environment by always asking students for personal feedback throughout the sections and making sure he knows each of us and can help us through each assignment.\"",

  "\"He made sure everyone felt welcomed and supported by having an open perspective during discussion.\"",

  "\"He's super supportive and is an amazing professor!\"",

  "\"During discussion sections, Michael would happily answer any questions we have about the material. He never made us feel bad for not understanding, and would try to break it down in a way that made sense to us.\"",

  "\"Michael was very kind to all of us. In talking to my classmates, we all agree how appreciative we are to have had him as our TA. He explains concepts effectively and concisely as well.\"",

  "\"Mike was amazing and super helpful, never felt anxious going into his class because he was so kind and welcoming. The way he reviews and went about his discussion incredibly helped me learn the content of the class.\"",

  "\"Mike is a well-seasoned educator. He gave an excellent guest lecture on the Frankfurt School.\"",

];